export const DATE_FORMATS = {
  FILTER_FORMAT: 'yyyy/MM/dd',
  DISPLAY_FORMAT: 'MM/DD/YYYY',
  DISPLAY_WITH_TIME: 'MM/DD/YYYY h:mm A',
} as const
